import { 
    Accordion, 
    AccordionSummary, 
    AccordionDetails, 
    Typography, 
    Box, 
    Button, 
    Card,
    CardContent
  } from "@mui/material";
  import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
  
  export const PaymentAccordion = ({
    payments,
    onEditPayment,
    onDeletePayment,
    onAddPayment
  }: {
    payments: any[],
    onEditPayment: (payment: any) => void,
    onDeletePayment: (paymentId: number) => void,
    onAddPayment: () => void
  }) => {
    const safeNumber = (value: any): number => (isNaN(Number(value))) ? 0 : Number(value);
    
    return (
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">Payment History</Typography>
            </AccordionSummary>
            <AccordionDetails>
            {payments.length > 0 ? (
  payments.map((payment) => (
    <Box
      key={payment.id}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      mb={1}
      p={1}
      borderRadius={2}
    >
      <Box>
        <Typography>{new Date(payment.payment_date).toLocaleDateString()}</Typography>
        <Typography>${safeNumber(payment.amount).toFixed(2)}</Typography>
        {payment.taken_by && (
  <Typography variant="body2" color="text.secondary">
    Taken By: {payment.taken_by} ({payment.taken_by_email})
  </Typography>
)}

      </Box>
      <Box>
        <Button
          size="small"
          onClick={() => onEditPayment(payment)}
        >
          Edit
        </Button>
        <Button
          size="small"
          color="error"
          onClick={() => onDeletePayment(payment.id)}
        >
          Delete
        </Button>
      </Box>
    </Box>
  ))
) : (
  <Typography>No payments made yet.</Typography>
)}

            </AccordionDetails>
          </Accordion>
        </CardContent>
        <Box p={2} display="flex" justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            onClick={onAddPayment}
          >
            Add Payment
          </Button>
        </Box>
      </Card>
    );
  };